"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function extractArticle(_a) {
    var date = _a.date, favicon = _a.favicon, id = _a.id, image = _a.image, name = _a.name, text = _a.text, url = _a.url;
    return { date: date, favicon: favicon, id: id, image: image, name: name, text: text, url: url };
}
exports.extractArticle = extractArticle;
//# sourceMappingURL=article.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/domain/article.js
// module id = 167
// module chunks = 0